import * as trace from 'owa-trace';
import getLocalStorageKey from './getLocalStorageKey';
import isLocalStorageSupported from './isLocalStorageSupported';

/**
 * Sets value corresponding to key in localStorage.
 */
/* eslint-disable-next-line @typescript-eslint/no-explicit-any --
 * See aka.ms/mini-lint-errors
 *	> Unexpected any. Specify a different type. */
const setItem = (key: string, value: any) => {
    if (isLocalStorageSupported()) {
        try {
            const localStorageKey = getLocalStorageKey(key);
            window.localStorage.setItem(localStorageKey, JSON.stringify(value));
        } catch (error) {
            if (window.localStorage.length === 0) {
                // This can be incognito mode as length is zero and error was caught while setting item.
                // In some browsers, QUOTA is 0 in incognito mode
            } else {
                // Log error as genuine quota exceeded.
                // This will help identify if the assumption that users will not have data more than 5 MB is correct or not.
                trace.errorThatWillCauseAlert(`[setItem]: ${error}`);
            }
        }
    }
};

export default setItem;
